import {Card} from '@esgi/ui/layout';
import {styled} from '@esgi/ui/theme';

export const CardSeparator = styled(Card.Separator, {
	width: '100%',
	marginLeft: 'unset',
	marginRight: 'unset',
	borderRadius: 1,
});
